var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { WindowService } from './../../services/window.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BountyService } from 'src/app/services/bounty.service';
import { GAME_MODES, transformFormDataToBountyRequest, transformValidationErrors, durationOptions } from '../create-bounty/create-bounty.component';
var EditBountyComponent = /** @class */ (function () {
    function EditBountyComponent(bountyService, route, windowService, router) {
        this.bountyService = bountyService;
        this.route = route;
        this.windowService = windowService;
        this.router = router;
        this.submitting = false;
        this.success = false;
        this.gameModes = GAME_MODES;
        this.submitFailed = false;
        this.addDuration = false;
        this.durationOptions = durationOptions;
        this.duration = this.durationOptions.find(function (o) { return o.name === '30 days'; });
    }
    EditBountyComponent.prototype.ngOnInit = function () {
        this.form = new FormGroup({
            gameMode: new FormControl(this.gameMode, [Validators.required]),
            tournamentName: new FormControl(this.tournamentName),
            tournamentPlace: new FormControl(this.tournamentPlace),
            addDuration: new FormControl(this.addDuration),
            duration: new FormControl(this.duration),
        });
        var preRenderedData = this.windowService.appData;
        if (preRenderedData) {
            this.mapAppDataToState(preRenderedData);
        }
        else {
            this.fetchBounty();
        }
    };
    EditBountyComponent.prototype.fetchBounty = function () {
        return __awaiter(this, void 0, void 0, function () {
            var id, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = this.route.snapshot.paramMap.get('id');
                        return [4 /*yield*/, this.bountyService.get(id)];
                    case 1:
                        data = _a.sent();
                        this.mapAppDataToState(data);
                        return [2 /*return*/];
                }
            });
        });
    };
    EditBountyComponent.prototype.mapAppDataToState = function (_a) {
        var bounty = _a.bounty;
        this.bounty = bounty;
        this.form.patchValue({
            gameMode: bounty.mode,
            tournamentName: bounty.tournament_name,
            tournamentPlace: bounty.tournament_place,
        });
    };
    Object.defineProperty(EditBountyComponent.prototype, "canChangeReward", {
        get: function () {
            return this.bounty.payment_type !== 'pool';
        },
        enumerable: true,
        configurable: true
    });
    EditBountyComponent.prototype.submitForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var formData, parsedFormData, bounty, e_1, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.form.valid) {
                            this.submitFailed = true;
                            return [2 /*return*/];
                        }
                        this.submitting = true;
                        this.errors = undefined;
                        this.success = false;
                        formData = this.form.value;
                        parsedFormData = transformFormDataToBountyRequest(formData);
                        if (!this.form.get('addDuration').value) {
                            parsedFormData.duration = undefined; // shouldn't be set if option is false
                        }
                        parsedFormData.addDuration = undefined; // not needed
                        if (!this.canChangeReward && parsedFormData.reward !== this.bounty.reward) {
                            this.errors = ['The reward cannot be changed on a pool bounty'];
                            this.submitFailed = true;
                            this.submitting = false;
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.bountyService.update(parsedFormData, this.bounty.id)];
                    case 2:
                        bounty = (_a.sent()).bounty;
                        this.mapAppDataToState({ bounty: bounty });
                        this.success = true;
                        this.router.navigate(['/bounties', this.bounty.id]);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1.error) {
                            if (e_1.error.errors) {
                                this.errors = transformValidationErrors(e_1.error.errors);
                            }
                            else if (e_1.error.error) {
                                this.errors = [e_1.error.error];
                            }
                        }
                        else {
                            error = e_1.status === 401
                                ? 'You are not authorized to do this. Are you logged in?'
                                : 'A server error occured';
                            this.errors = [error];
                        }
                        this.submitting = false;
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EditBountyComponent.prototype.hasError = function (controlKey) {
        var control = this.form.get(controlKey);
        var touchedOrSubmitted = !control.pristine || this.submitFailed;
        return control.errors && touchedOrSubmitted;
    };
    Object.defineProperty(EditBountyComponent.prototype, "labelClass", {
        get: function () {
            return this.bountyService.getBountyLabelClass(this.bounty);
        },
        enumerable: true,
        configurable: true
    });
    return EditBountyComponent;
}());
export { EditBountyComponent };
